import crypto from 'crypto';

/**
 * Strip highlight markers from text
 */
export var cleanExcerpt = function cleanExcerpt(text) {
  return text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
};

// copied over from @confluence/hash
var hash = function hash(algorithm, data) {
  var asBytes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hash = crypto.createHash(algorithm);
  hash.update(data);
  if (asBytes) {
    return Array.from(hash.digest());
  }
  return hash.digest('hex');
};
export var hashDataAsByte = function hashDataAsByte(data) {
  return hash('sha256', data, true);
};
export var hashData = function hashData(data) {
  return hash('sha256', data);
};
export var getUserPath = function getUserPath(userId, primaryProduct, orgId, cloudId) {
  if (primaryProduct === 'confluence') {
    return "/wiki/people/".concat(userId);
  } else if (primaryProduct === 'townsquare') {
    return "/o/".concat(orgId, "/people/").concat(userId, "?cloudId=").concat(cloudId);
  }
};
export var getTeamPath = function getTeamPath(teamId, primaryProduct, orgId, cloudId) {
  if (primaryProduct === 'confluence') {
    return "/wiki/people/team/".concat(teamId);
  } else if (primaryProduct === 'townsquare') {
    return "/o/".concat(orgId, "/people/team/").concat(teamId, "?cloudId=").concat(cloudId);
  }
};